import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import { useRef, useState } from "react";
import ProgressBar from "./ProgressBar";
import V1_Red from "./3D_irrigation_renders/V1_red.svg";
import V2_Red from "./3D_irrigation_renders/V2_red.svg";
import V3_Red from "./3D_irrigation_renders/V3_red.svg";
import V4_Red from "./3D_irrigation_renders/V4_red.svg";
import V5_Red from "./3D_irrigation_renders/V5_red.svg";
import V6_Red from "./3D_irrigation_renders/V6_red.svg";
import V7_Red from "./3D_irrigation_renders/V7_red.svg";
import V8_Red from "./3D_irrigation_renders/V8_red.svg";
import V9_Red from "./3D_irrigation_renders/V9_red.svg";
import V10_Red from "./3D_irrigation_renders/V10_red.svg";
import V11_Red from "./3D_irrigation_renders/V11_red.svg";
import V12_Red from "./3D_irrigation_renders/V12_red.svg";
import V13_Red from "./3D_irrigation_renders/V13_red.svg";
import V14_Red from "./3D_irrigation_renders/V14_red.svg";
import V1_Green from "./3D_irrigation_renders/V1_Green.svg";
import V2_Green from "./3D_irrigation_renders/V2_Green.svg";
import V3_Green from "./3D_irrigation_renders/V3_Green.svg";
import V4_Green from "./3D_irrigation_renders/V4_Green.svg";
import V5_Green from "./3D_irrigation_renders/V5_Green.svg";
import V6_Green from "./3D_irrigation_renders/V6_Green.svg";
import V7_Green from "./3D_irrigation_renders/V7_Green.svg";
import V8_Green from "./3D_irrigation_renders/V8_Green.svg";
import V9_Green from "./3D_irrigation_renders/V9_Green.svg";
import V10_Green from "./3D_irrigation_renders/V10_Green.svg";
import V11_Green from "./3D_irrigation_renders/V11_Green.svg";
import V12_Green from "./3D_irrigation_renders/V12_Green.svg";
import V13_Green from "./3D_irrigation_renders/V13_Green.svg";
import V14_Green from "./3D_irrigation_renders/V14_Green.svg";

const ValveComponent = ({
  data,
  index,
  chackData,
}: {
  data: any;
  index: any;
  chackData?: any;
}) => {
  const progressInterval = useRef<NodeJS.Timeout | null>(null);
  const [now, setNow] = useState<number>(0);
  const [progressBar, setProgressBar] = useState<boolean>(false);

  const redImages = [
    null, V1_Red, V2_Red, V3_Red, V4_Red, V5_Red, V6_Red, V7_Red,
    V8_Red, V9_Red, V10_Red, V11_Red, V12_Red, V13_Red, V14_Red,
  ];

  const greenImages = [
    null, V1_Green, V2_Green, V3_Green, V4_Green, V5_Green, V6_Green, V7_Green,
    V8_Green, V9_Green, V10_Green, V11_Green, V12_Green, V13_Green, V14_Green,
  ];

  const valveNum = parseInt(data.valveNumber?.match(/\d+/)?.[0] || "0", 10);
  const sov = `SOV ${valveNum}`;

  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(100); // ✅ response milte hi turant 100%
    setTimeout(() => {
      setNow(0);
      setProgressBar(false);
    }, 300); // thoda visual pause taaki 100% dikh jaye
  
  };

  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0);
    setProgressBar(true);

    const stepTime = 250;
    const duration = 35000;
    const capPercent = 95; 
    const increment = capPercent / (duration / stepTime);

    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const sendSovCommand = async () => {
    try {
      const res = await ApiService.axiosApi("/command/sov/open/close", {
        method: "POST",
        data: {
          chakId: data.chakId,
          sovNo: Number(sov.replace("SOV ", "")),
          open_Close: data.on ? 0 : 1,
        },
      });

      if (res.success) {
        toast.success(`${data.on ? "Valve Close" : "Valve Open"}`);
      } else {
        toast.error("failed. please retry again");
      }
    } catch (e) {
      console.error("error in sov open close:", e);
    
    } finally {
      stopProgressBar();
    }
  };

  const isLine1 = ["V01", "V03", "V05", "V07", "V09", "V11", "V13"].includes(
    data.valveNumber
  );

  const imageIndex = index * 1 + 1;
  const imgSrc = data.on
    ? greenImages[imageIndex]
    : redImages[imageIndex] || V2_Red;

  const handleClick = () => {
    if (progressBar) return; 
    if (!chackData.romsAuto) {
      startProgressBar();
      sendSovCommand();
    } else {
      toast.error("Please select manual mode");
    }
  };

  const imageElement = isLine1 ? (
    <>
      <img key={data.id} id={`V${imageIndex}_Red`} src={imgSrc || V1_Red} alt="" />
      <button
        onClick={handleClick}
        id={`V${imageIndex}_Red`}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50px",
          top: "10px",
          marginLeft: "5px",
          padding: "0px",
          zIndex: 10,
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          position: "absolute",
        }}
        className={data.valveNumber}
      >
        <div
          className="p-0"
          style={{
            position: "absolute",
            width: "35px",
            height: "20px",
            top: "50px",
            right: "75px",
            zIndex: 4,
          }}
        >
          {data.valveNumber}
        </div>
      </button>
    </>
  ) : (
    <>
      <img key={data.id} id={`V${imageIndex}_Red`} src={imgSrc || V1_Red} alt="" />
      <button
        onClick={handleClick}
        id={`V${imageIndex}_Red`}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50px",
          top: "10px",
          marginLeft: "35px",
          padding: "0px",
          zIndex: 10,
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
        }}
        className={data.valveNumber}
      >
        <div
          style={{
            paddingLeft: "60px",
            width: "40px",
            height: "40px",
            borderRadius: "50px",
            top: "10px",
            zIndex: 10,
          }}
        >
          {data.valveNumber}
        </div>
      </button>
    </>
  );

  return (
    <>
      {progressBar && (
        <ProgressBar
          totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: "absolute",
            height: "25px",
            zIndex: 1000,
            backgroundColor: "whitesmoke",
            borderRadius: "4px",
            width: "1136px",
            marginLeft: "203px",
            bottom: "483px",
          }}
        />
      )}
      {imageElement}
    </>
  );
};

export default ValveComponent;